export const TemplateRouteParameters = {
  LayoutId: 'layoutId',
} as const;
